import React from 'react'

export default function RecaptchaNotice() {
  return (
    <div className="mt-3 p-3 bg-light border rounded">
      <div className="d-flex align-items-start">
        <i className="fas fa-shield-alt text-primary me-2 mt-1"></i>
        <div>
          <h6 className="mb-1">Security Protected</h6>
          <p className="mb-1 small text-muted">
            This site is protected by reCAPTCHA and Firebase App Check to ensure security and prevent abuse.
          </p>
          <div className="small text-muted">
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
              Google Privacy Policy
            </a>
            {' | '}
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}